const ENABLE_LOADING_MODE = 'ENABLE_LOADING_MODE';
export default class ConfigUtils {
  public static isEnableLoadingMode() {
    return this.getConfigByKey(ENABLE_LOADING_MODE);
  }

  private static getConfigByKey(key: string) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return config && config[key];
  }
}
